import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {FormDefinitionFormFieldModel} from '../formDefinitionFormField.model';
import {FormDefinitionFieldConverter} from '../../../../field/api/entity/converter/formDefinitionField.converter';

@Injectable()
export class FormDefinitionFormFieldConverter extends HttpModelConverter<FormDefinitionFormFieldModel> {

    constructor(private fieldConverter: FormDefinitionFieldConverter) {
        super();
    }

    protected createInstance(): FormDefinitionFormFieldModel {
        return new FormDefinitionFormFieldModel();
    }

    protected enrichObject(result: FormDefinitionFormFieldModel, src: FormDefinitionFormFieldModel) {
        result.fieldDefinition = this.fieldConverter.convert(src.fieldDefinition);

    }

}
